import React from 'react';
import { Button } from './Button';
import { Star } from 'lucide-react';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-16 pb-24 md:pt-24 md:pb-32 overflow-hidden bg-sand-50 bg-terrazzo" data-id="element-175">
      {/* Organic Background Elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-sage-100/50 organic-blob-1 blur-3xl opacity-60 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-176"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-terracotta-400/10 organic-blob-2 blur-3xl opacity-50 translate-y-1/3 -translate-x-1/4 pointer-events-none" data-id="element-177"></div>
      <div className="luminous-overlay" data-id="element-178"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-179">
        <div className="max-w-4xl mx-auto text-center" data-id="element-180">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm border border-gold-300/50 text-concrete-700 px-5 py-2 rounded-full text-xs md:text-sm font-medium mb-8 shadow-sm" data-id="element-181">
            <div className="flex gap-0.5" data-id="element-182">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-gold-400 text-gold-400" data-id="element-183" />)}
            </div>
            <span className="ml-2 tracking-wide" data-id="element-184">
              +2,500 alumnas satisfechas
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-7xl font-semibold text-concrete-900 leading-[1.1] mb-6 text-balance text-embossed" data-id="element-185">
            Descubre Cómo Crear <br className="hidden md:block" data-id="element-186" />
            <span className="text-metallic-gold italic" data-id="element-187">
              Hermosas Piezas en Cemento
            </span>
          </h1>

          <p className="text-base md:text-xl text-concrete-600 mb-10 max-w-2xl mx-auto text-balance font-light leading-relaxed" data-id="element-188">
            El método paso a paso para diseñar macetas, bandejas y decoración
            moderna desde casa. Convierte tu pasión en un pasatiempo relajante o
            en un negocio rentable hoy mismo,{' '}
            <span className="font-medium text-concrete-800" data-id="element-189">
              sin experiencia previa
            </span>
            .
          </p>

          <div className="flex flex-col items-center gap-5" data-id="element-190">
            <Button size="xl" onClick={scrollToOffer} className="w-full sm:w-auto shadow-premium" data-id="element-191">
              ¡SÍ, QUIERO EMPEZAR HOY!
            </Button>
            <p className="text-xs md:text-sm text-concrete-500 flex items-center gap-2 tracking-wide uppercase" data-id="element-192">
              <span className="w-1.5 h-1.5 rounded-full bg-sage-500 animate-pulse" data-id="element-193"></span>
              Acceso inmediato y de por vida
            </p>
          </div>

          <div className="mt-20 relative mx-auto max-w-3xl" data-id="element-194">
            {/* Sparkle details */}
            <div className="sparkle-detail top-10 -left-10" data-id="element-195"></div>
            <div className="sparkle-detail bottom-20 -right-8" style={{
            animationDelay: '1s'
          }} data-id="element-196"></div>

            <div className="relative rounded-[2rem] overflow-hidden shadow-premium bg-white p-2 md:p-4 border border-sand-200" data-id="element-197">
              <div className="aspect-[4/3] md:aspect-video rounded-2xl overflow-hidden relative bg-sand-100" data-id="element-198">
                <img src="https://cdn.shopify.com/s/files/1/0999/7487/3381/files/bundle.png?v=1779992163" alt="Bundle completo Arte con Cemento — Programa + bonos + moldes de silicona" className="w-full h-full object-contain p-4 md:p-8 transform hover:scale-105 transition-transform duration-700" data-id="element-199" />
                <div className="absolute inset-0 bg-gradient-to-t from-concrete-900/20 to-transparent pointer-events-none" data-id="element-200"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}